import { render, staticRenderFns } from "./xswyh.vue?vue&type=template&id=034b3b44&scoped=true"
import script from "./xswyh.vue?vue&type=script&lang=js"
export * from "./xswyh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034b3b44",
  null
  
)

export default component.exports